import { defaultApi } from '@/plugins/api/defaultApi'

export default {
  name: 'creditPay/payment',
  namespaced: true,
  state: {
    offer: null,
  },
  getters: {
    /**
     * 한도 관련
     */
    getTotalLimitAmount(state) {},
    getInUseAmount(state) {},
    getAvailableAmount(state) {},
  },
  mutations: {
    setOffer(state, accounts) {
      state.wholesalerAccounts = accounts
    },
  },
  actions: {
    async getCreditPayOffer({ state, commit }) {
      const { data } = await defaultApi.getLoansOffersCurrent({
        repayment_period_in_days: 75,
        loan_type: 'normal',
      })
      commit('setOffer', data)
      return data
    },
  },
}
